import { Field, Formik, Form, ErrorMessage } from "formik";
import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { IoClose } from "react-icons/io5";
import axios from "axios";
import { MODULE_URLS } from "../../constants/module-urls";
import { toast } from "react-toastify";

function AddOtherDetails({ open, onClose }) {
  const initialValues = {
    otherDetail: "",
  };

  const onSubmit = async (values) => {
    const detailText = {
      detailText: values.otherDetail,
    };
    const response = await axios.post(
      `${MODULE_URLS.ADD_OTHER_DETAIL_TEXT}`,
      detailText
    );
    if (response.status === 200) {
      toast.success("Other Detail Added Successfully!");
      onClose();
    }
  };
  const customModalStyles = {
    content: {
      width: "40%",
      height: "30vh",
      margin: "auto",
      padding: "10px 20px",
      zIndex: "",
    },
  };

  return (
    <Modal
      isOpen={open}
      shouldReturnFocusAfterClose={false}
      style={{
        ...customModalStyles,
        content: {
          ...customModalStyles.content,
          width: "80%",
        },
      }}
    >
      <div>
        <span
          style={{
            display: "flex",
            justifyContent: "space-between",
            borderBottom: "1px solid #000000",
          }}
        >
          <span className="modal-head-Text">Add Other Details</span>
          <IoClose
            color="#000000"
            size={"23px"}
            onClick={() => {
              onClose();
            }}
          />
        </span>
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          enableReinitialize={true}
        >
          {({ values }) => (
            <Form>
              <div
                style={{
                  paddingBottom: "5px",
                }}
              >
                <div className="create-financial-main-input-container">
                  <div
                    className="create-admission-inner-first-input-container"
                    style={{ width: "100%", marginTop: "10px" }}
                  >
                    <div className="label-text-active">
                      {" "}
                      Enter Other Details
                    </div>
                    <Field
                      name="otherDetail"
                      style={{
                        width: "100%",
                        padding: "5px 10px",
                        height: "50px",
                        marginTop: "5px",
                        borderRadius: "5px",
                      }}
                    />
                    <ErrorMessage
                      name="otherDetail"
                      component="div"
                      className="add-staff-error"
                    />
                  </div>
                </div>
              </div>
              <div
                style={{ position: "absolute", bottom: "20px", width: "auto" }}
              >
                <div className="d-flex align-items-center justify-content-end gap-3">
                  <button
                    type="submit"
                    className="list-add-bttn"
                    onClick={() => {
                      onClose();
                    }}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="list-add-bttn">
                    Submit
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  );
}
export default AddOtherDetails;
